import NotFooterLayout from "layouts/NotFooterLayout";
import Shipping from "components/ShippingManage";



function ShippingPage() {
//  const dispatch = useAppDispatch();

  //show footer
 // dispatch(setFooterShow(true));
  return (
    <>
     {/* footerComponent={<FooterCreateOrder />} */}
      <NotFooterLayout namePage="การส่งสินค้า"   >
        <div className="layout-content">
          <Shipping  />
        </div>
      </NotFooterLayout>
    </>
  );
}

export default ShippingPage;